<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-data-table :headers="headers" :items="teams" :search="search">
          <template #top>
            <v-toolbar flat>
              <v-toolbar-title>Users</v-toolbar-title>
              <v-divider class="mx-4" inset vertical />
              <v-spacer />
              <inertia-link v-if="$page.props.jetstream.canCreateTeams" class="v-list-item v-list-item--link theme--light" :href="route('teams.create')" method="get" @click="$emit('input')">
                <v-list-item-action>
                  <v-icon>
                    mdi-plus
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Create New Team
                  </v-list-item-title>
                </v-list-item-content>
              </inertia-link>
            </v-toolbar>
          </template>
          <template #[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">
              mdi-pencil
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Admin'
import { formattedDateTimeString } from '@/plugins/formatDate.js'

export default {
   name: 'TeamsIndex',
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: this.title ? this.title : 'Teams',
      }
   },
   layout: (h, page) => h(Layout, [page]),
   props: {
      teams: {
         type: Array,
         required: true,
      },
   },
   data () {
      return {
         headers: [
            { text: 'Name', value: 'name' },
            { text: 'Team Leiter', value: 'teamLeader' },
            { text: 'IT-Hunter', value: 'it_hunter' },
            { text: 'Vertrieb', value: 'vertrieb' },
            { text: 'Name', value: 'name' },
            { text: '', value: 'actions', sortable: false },
         ],
      }
   },
   computed: {
      formTitle () {
         return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      }
   },

   methods: {
      getDateString (dateVal) {
         return formattedDateTimeString(dateVal)
      },
      editItem (item) {
         this.$inertia.visit(this.route('admin.team.edit', item))
      },
   },
}
</script>

<style></style>
